/* eslint-disable @typescript-eslint/no-unused-vars,unused-imports/no-unused-imports */
import { Type } from 'typebox';
export const DealerPrimaryContactMethodSchema = Type.Union([Type.Literal("discord"), Type.Literal("email"), Type.Literal("telegram"), Type.Literal("twitch"), Type.Literal("twitter"), Type.Literal("website"), Type.Literal("youtube")], { "$id": "DealerPrimaryContactMethod" });
export const DealerPrimaryContactMethod = {
    'Discord': 'discord', 'Email': 'email', 'Telegram': 'telegram', 'Twitch': 'twitch', 'Twitter': 'twitter', 'Website': 'website', 'Youtube': 'youtube',
};
